import { render } from "./App.vue?vue&type=template&id=21e1cbe0"
const script = {}

import "./App.vue?vue&type=style&index=0&id=21e1cbe0&lang=scss"
script.render = render

export default script